var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrequalV2BackgroundShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 1440,
    height: 360,
    viewBox: "0 0 1440 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background-shape",
    clipPath: "url(#clip0_0_254)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 360,
    fill: "url(#paint0_linear_0_254)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M730.5 165.299C850 110.437 1216.5 79.0189 1440 136.968V417.473C1257.5 417.473 1025.26 420.143 877.5 503.1C640 636.442 0 600.626 0 600.626V356.829C0 356.829 252.134 384.919 730.5 165.299Z",
    fill: "url(#paint1_linear_0_254)",
    fillOpacity: 0.04
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_254",
    x1: 812.665,
    y1: -0.00000299838,
    x2: 789.291,
    y2: 370.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.271231,
    stopColor: "#F4EEFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524038,
    stopColor: "#E8E9F7",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773268,
    stopColor: "#FAEEFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_254",
    x1: 1440,
    y1: 326.01,
    x2: -4.37802,
    y2: 326.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.389423,
    stopColor: "#133F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#0B98F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 360,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrequalV2BackgroundShape);
export default __webpack_public_path__ + "static/media/prequal_v2_background_shape.ffa81fc2.svg";
export { ForwardRef as ReactComponent };